import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path:'/',
      redirect:'/person/index'
    },
    {
      path: '/login/index',
      name: 'login',
      component: () => import('../views/login/index.vue'),//登录页
      meta:{
        title: '登录'
      }
    },
    {
      path: '/login/login',
      name: 'gologin',
      component: () => import('../views/login/login.vue'),//登录页
      meta:{
        title: '登录'
      }
    },
    {
      path: '/login/register',
      name: 'register',
      component: () => import('../views/login/register.vue'),//注册页
      meta:{
        title: '注册'
      }
    },
    {
      path: '/login/wxpower',
      name: 'wxpower',
      component: () => import('../views/login/wxpower.vue'),//微信授权注册页
      meta:{
        title: '微信授权注册'
      }
    },
    {
      path: '/login/xieyi',
      name: 'xieyi',
      component: () => import('../views/login/xieyi.vue'),//用户注册协议和隐私政策
      meta:{
        title: '用户注册协议和隐私政策'
      }
    },
    {
      path: '/person/index',
      name: 'index',
      component: () => import('../views/person/index.vue'),//个人中心首页
      meta:{
        title: '个人中心'
      }
    },
    {
      path: '/person/information',
      name: 'information',
      component: () => import('../views/person/information.vue'),//完善资料
      meta:{
        title: '完善资料'
      }
    },
    {
      path: '/person/account',
      name: 'account',
      component: () => import('../views/person/account.vue'),//加入协会
      meta:{
        title: '加入协会'
      }
    },
    {
      path: '/person/safe',
      name: 'safe',
      component: () => import('../views/person/safe.vue'),//账户安全
      meta:{
        title: '账户安全'
      }
    },
    {
      path: '/person/message',
      name: 'message',
      component: () => import('../views/person/message.vue'),//消息中心
      meta:{
        title: '消息中心'
      }
    },
    {
      path: '/person/collect',
      name: 'collect',
      component: () => import('../views/person/collect.vue'),//会员收藏
      meta:{
        title: '会员收藏'
      }
    },
    {
      path: '/person/suggestion',
      name: 'suggestion',
      component: () => import('../views/person/suggestion.vue'),//投诉建议
      meta:{
        title: '投诉建议'
      }
    },
    {
      path: '/person/supply',
      name: 'supply',
      component: () => import('../views/person/supply.vue'),//我的供需
      meta:{
        title: '我的供需'
      }
    },
    {
      path: '/form/index',
      name: 'freeform',
      component: () => import('../views/form/index.vue'),  //自定义表单
      meta:{
        title: ''
      }
    },
    {
      path: '*', // 通配符路由
      redirect: '/' // 重定向到首页
      // 或者如果你想显示一个404页面，可以这样设置：
      // component: NotFoundPage
    }

  ]
})

router.onError((error)=>{
  console.log(error)
})

// router.beforeEach((to, from, next) => {
//     //console.log(to)
//     if (to.path=='/login/register'||to.path=='/login/xieyi') {
//       window.localStorage.removeItem("token")
//       next()
//     }else if(to.path=='/form/index'){
//       let user = window.localStorage.getItem('token')
//       if (!user) {
//         next({
//             path: '/login/login'
//         })
//         window.localStorage.setItem('shouldTo',JSON.stringify(to.query))
//       }else{
//         next()
//       }
//     }else if (to.path.startsWith('/login/')) {
//         let user = window.localStorage.getItem('token')
//         if(user){
//           let $toQuery=window.localStorage.getItem('shouldTo')
//           if ($toQuery) {
//             window.localStorage.removeItem("shouldTo")
//             next({
//               path: '/form/index',
//               query: JSON.parse($toQuery)
//             })
//           }else{
//             next({
//               path: '/person/index'
//             })
//           }
//         }else{
//           window.localStorage.removeItem('token')
//           next()
//         }
//     } else {
//         let user = window.localStorage.getItem('token')
//         //console.log(user)
//         if (!user) {
//             next({
//                 path: '/login/login'
//             })
//         } else {
//           let $toQuery=window.localStorage.getItem('shouldTo')
//           if ($toQuery) {
//             window.localStorage.removeItem("shouldTo")
//             next({
//               path: '/form/index',
//               query: JSON.parse($toQuery)
//             })
//           }else{
//             next()
//           }
//         }
//     }
// });

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js